import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button
} from '@chakra-ui/react'
import { useRef } from 'react'

type Props = {
  isOpen:boolean;
  onClose:()=>void;
  onDelete:()=>void;
}

const TransitionDialog = (props:Props) =>  {
  const {isOpen,onClose,onDelete} = props
  const cancelRef = useRef<HTMLButtonElement>(null)
  return (
    <>
      <AlertDialog
        motionPreset='slideInBottom'
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>确认删除</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            是否确认删除？
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              取消
            </Button>
            <Button colorScheme='red' ml={3} onClick={onDelete}>
              确认
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

export default TransitionDialog